import { Injectable }    from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable }    from 'rxjs/Observable';
import {ConfirmationService} from "primeng/primeng";

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {

  constructor(private srvConfirmation: ConfirmationService) { }

  canDeactivate(component: CanComponentDeactivate) : boolean {
    console.log("guard comp", component);
    console.log("call guard deactivate");
    return true;

    // if (component.canDeactivate)  {
    //
    //   let confirm: boolean = false;
    //
    //   this.srvConfirmation.confirm({
    //     message: "yes or no?"});
    //
    //   Promise.all([
    //   this.srvConfirmation.confirm({
    //     message: "yes or no?",
    //     accept: () => {
    //       console.log("accept");
    //       confirm = true;
    //     },
    //     reject: () => {
    //       confirm = false;
    //     }
    //   })]).then(() => { console.log("confirm", confirm); return confirm; });
    // }
    // else return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/utils/can-deactivate-guard.service.ts